import { z } from 'zod';

/**
 * PRE-147: admin test / transactional push via OneSignal.
 * External ID = Prepzio auth `user.id` (set by mobile `OneSignal.login`).
 */

/** Deep-link / custom payload keys for the mobile click handler (PRE-145). */
export const pushDataSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]));

export const sendPushInputSchema = z.object({
  /** Auth user id → OneSignal External ID. */
  userId: z.string().trim().min(1).max(128),
  heading: z.string().trim().min(1).max(100),
  body: z.string().trim().min(1).max(500),
  /** Optional custom data (e.g. `{ route: "/(tabs)/home" }`). */
  data: pushDataSchema.optional(),
  /**
   * When true, skip `user_preferences.push_enabled` (admin force-test only).
   * Product paths must leave this unset/false (BR-79).
   */
  bypassPreferenceGate: z.boolean().optional(),
});

export type SendPushInput = z.infer<typeof sendPushInputSchema>;

export const sendPushResultSchema = z.object({
  notificationId: z.string().nullable(),
  skipped: z.boolean(),
  skipReason: z.enum(['push_disabled', 'not_configured', 'no_recipients']).optional(),
});

export type SendPushResult = z.infer<typeof sendPushResultSchema>;
